<template>
    <div v-if="show" class="mask">
        <div class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">{{title}}</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">内容</div>
                        <div class="value" id="content"> <RichText  ref="rtf"  class="full-width" v-model="formData.content"   /></div>
                    </div>
                </div>
            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box">
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">关闭</div>  
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="del">删除</div>     
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="save">保存</div>   
            </div>
        </div>
    </div>
    

</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import {saveReplyFile,deleteReply} from '@/api/api.js';
    

    export default {
        name:'DocReplyModal',
        created() {
        },
        components:{RichText},
        props:{
            title:{},
            open:{},
            mdata:{},
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    if (newValue == true) {
                        if (this.mdata != null) {
                            this.formData.id = this.mdata.id;
                            this.formData.content = this.mdata.content;                               
                        }
                    } 
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                show: null,
                formData:{
                },
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),

            }
        },
        methods:{
            
            close() {
                this.$emit("close")
            },
            del() {

                this.$showMsgBox({
                    caption:"询问",
                    msg: '确定要删除吗？',
                    callback:(data) => {
                        if (data == "yes") {
                            this.$showLoading();
                            deleteReply(this.formData.id).then((res) => {
                                if (res.data.success == true) {
                                    this.$closeLoading(); 
                                    this.$emit("confirm")
                                }             
                            }) 
                        } 
                    }
                })
            },
            save() {
                this.$showLoading();
                saveReplyFile(this.formData).then((res) => {
                    if (res.data.success == true) {
                        this.$closeLoading(); 
                        this.$emit("confirm")
                    }             
                }) 
            }
            
            

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 15px;
    }
    .doc-edit-modal {
        width: 1100px;
        height: 835px;
    }
    .edit-area {
       width: 1060px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/DocReplyModal.vue